import { LicenseManager } from "ag-grid-enterprise";

import GridTable from "./GridTable";

LicenseManager.setLicenseKey(process.env.AG_LICENSE as string);

export default GridTable;
export type { GridTableProps, ColDef, ColGroupDef, ColumnDef } from "./typing";
